export default import.meta.ROLLDOWN_FILE_URL_WPGYjwIlzWVNM1bYhOc83w